import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IconWrapper, StyledFieldFooter } from './FieldFooter.styles';
export const FieldFooter = ({ fieldFooterLabel, fieldFooterType, icon: Icon, id })=>!fieldFooterLabel ? null : /*#__PURE__*/ _jsxs(StyledFieldFooter, {
        $fieldFooterType: fieldFooterType,
        id: id,
        children: [
            Icon && /*#__PURE__*/ _jsx(IconWrapper, {
                children: /*#__PURE__*/ _jsx(Icon, {})
            }),
            /*#__PURE__*/ _jsx("span", {
                children: fieldFooterLabel
            })
        ]
    });

//# sourceMappingURL=FieldFooter.js.map